import { Form, Button } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { useState, useEffect} from 'react';
import { searchWhiteList} from '../../../../api/admin-api';

const SearchWhiteList = (props) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await searchWhiteList().then( response => {
          setData(response)
          return response
        })
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();
  }, [])

  return (
    <Link to="/">
      <Button icon="close" type="primary" key="console">
        Close
      </Button>
    </Link>
  );
};

const _SearchWhiteList = Form.create()(SearchWhiteList);
export default withRouter(_SearchWhiteList);
